import mediaCheck from 'mediacheck';
import { setAriaValue, toggleContent } from '../../utilities/accordion';

function addDropdownListeners(buttons, contentSections) {
  setAriaValue(buttons, 'aria-expanded', 'false');
  setAriaValue(contentSections, 'aria-hidden', 'true');

  buttons.forEach((button) => {
    button.addEventListener('click', (event) => toggleContent(event));
  });
}

function displayMainMenu(mainMenuEl) {
  mainMenuEl.style.display = 'flex';
}

function hideMenuLink(menuLinkEl) {
  menuLinkEl.style.display = 'none';
}

function isWindow(event) {
  return event.target === window;
}

function handleOutsideClick(event) {
  const activeButtonElements = document.querySelectorAll(
    '.cmp-main-navigation__button[aria-expanded="true"]',
  );

  // Check if any menus are open before trying to close one.
  if (activeButtonElements.length > 0) {
    // Grab the first button that isn't the current target button to close it
    const [activeButton] = [...activeButtonElements].filter((button) => button !== event.target);

    // If target is outside menu or outside the window
    if (
      activeButton && (
        isWindow(event)
        || !activeButton.contains(event.target)
      )
    ) {
      toggleContent({ target: activeButton });
    }
  }
}

function handleOutsideFocus(event) {
  const activeContentElement = document.querySelector('.cmp-main-navigation__content[aria-hidden="false"]');
  const activeButtonElement = document.querySelector(
    '.cmp-main-navigation__button[aria-expanded="true"]',
  );

  if (activeButtonElement && activeContentElement && !activeContentElement.contains(event.target)) {
    toggleContent({ target: activeButtonElement });
  }
}

export function initializeMenuAnimationListener() {
  const menuContent = document.getElementById('open-menu');
  menuContent.addEventListener('animationend', () => {
    menuContent.classList.remove('cmp-header__content--closing');
    menuContent.classList.remove('cmp-header__content--opening');
  });
}

export function initializeMainMenu() {
  const bodyContent = document.querySelector('body');
  const menuContent = document.querySelectorAll('.cmp-header__content');

  initializeMenuAnimationListener();

  hideMenuLink(
    document.querySelector('.cmp-main-navigation__link-to-footer'),
  );

  displayMainMenu(
    document.querySelector('.cmp-main-navigation > div:last-of-type'),
  );

  mediaCheck({
    media: '(min-width: 54.3125rem)', // 869px if you update this, update it in _variables.scss
    entry() {
      setAriaValue(menuContent, 'aria-hidden', 'false');
      bodyContent.classList.remove('menu--isOpen');
      document.addEventListener('click', handleOutsideClick);
      document.addEventListener('focusin', handleOutsideFocus);
      window.addEventListener('blur', handleOutsideClick);
    },
    exit() {
      setAriaValue(menuContent, 'aria-hidden', 'true');
      document.removeEventListener('click', handleOutsideClick);
      document.removeEventListener('focusin', handleOutsideFocus);
      window.removeEventListener('blur', handleOutsideClick);
    },
  });

  addDropdownListeners(
    document.querySelectorAll('.cmp-main-navigation__button'),
    document.querySelectorAll('.cmp-main-navigation__content'),
  );
}
